import { jsx as _jsx } from "react/jsx-runtime";
import { StatusBadge } from '@src/components/ui';
import ActionMenu from '../../../components/ActionMenu';
import { getBooleanStatusBadgeColors } from '../utils/formatters';
const toDisplayHierarchy = (category) => {
    if (!category.parent_name) {
        return category.name;
    }
    return `${category.parent_name} > ${category.name}`;
};
export const createProductCategoryColumns = (onEdit, onDelete) => [
    {
        key: 'name',
        header: 'Category',
        accessor: 'name',
        render: (category) => toDisplayHierarchy(category),
    },
    {
        key: 'slug',
        header: 'Slug',
        accessor: 'slug',
    },
    {
        key: 'header_title',
        header: 'Header Title',
        accessor: 'header_title',
        render: (category) => category.header_title || 'N/A',
    },
    {
        key: 'sort_order',
        header: 'Order',
        accessor: 'sort_order',
        render: (category) => category.sort_order,
    },
    {
        key: 'is_active',
        header: 'Status',
        accessor: 'is_active',
        render: (category) => {
            const label = category.is_active ? 'Active' : 'Inactive';
            const { background, text } = getBooleanStatusBadgeColors(!!category.is_active);
            return (_jsx(StatusBadge, { label: label, bgColor: background, color: text }));
        },
    },
    {
        key: 'actions',
        header: 'Actions',
        render: (category) => (_jsx("div", { onClick: (event) => event.stopPropagation(), children: _jsx(ActionMenu, { options: [
                    {
                        label: 'Edit',
                        onClick: () => onEdit(category),
                    },
                    {
                        label: 'Delete',
                        onClick: () => onDelete(category),
                        color: 'red',
                    },
                ] }) })),
    },
];
